/**
 * Agents Module - Conversations Page
 * 
 * Historial de conversaciones con agentes
 */
export default function Conversations() {
  return (
    <div className="px-4 py-6 sm:px-0">
      <h1 className="text-3xl font-bold text-tf-text mb-6">Conversaciones</h1>
      <div className="bg-tf-bg-card shadow rounded-lg p-6">
        <p className="text-tf-text-muted">Historial de conversaciones - En desarrollo</p>
      </div>
    </div>
  )
}













